module.exports = __webpack_public_path__ + "static/offices-content-image-5@2x-6cbb33868d85b03c46456b9e0f143f5b.jpg";